export default __webpack_public_path__ + "fef55857cc1c6633be3a8ccfc58b81e5.svg";